import React from "react";
import { useHistory } from "react-router";
import logo from "../images/logo.png";
import { useAtoms } from "../hooks/useAtoms";

// Shown on any application page whose application has been cancelled or deleted.
const ApplicationUnavailable = () => {
  const history = useHistory();
  const { setNavigationContent } = useAtoms();
  setNavigationContent(false);
  return (
    <div className="bg-img h-100 d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="container h-100">
        <div className="row align-items-center h-100">
          <div className="col-md-6 offset-md-3">
            <div className="card border-0">
              <div className="card-header bg-dark text-center">
                <img src={logo} alt="NCRR" style={{ width: "252px" }} />
              </div>
              <div className="card-body pt-1">
                <div className="text-center  p-1">
                  <div className="step--complete step--active text-center pt-2 mt-2 pb-0" style={{ cursor: "default" }}>
                    <span className="step__icon steps-1 mx-auto" style={{ backgroundColor: "#6c757d", borderColor: "#6c757d" }}>
                      <i className="fas fa-ban fs-1 "></i>
                    </span>
                    <br />
                  </div>
                  <div className="card-body pt-0 pb-0">
                    <h2 className="h1 mb-2 pb-2 d-block">Application No Longer Available</h2>
                    <p className="fs-6 text-muted mb-3">
                      This application has been cancelled or removed, so this page no longer exists. No further action is needed on it.
                      If you think this is a mistake, please contact NCRR.
                    </p>
                    <button type="button" className="btn btn-dark mb-2" onClick={() => history.push("/dashboard")}>
                      Go to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationUnavailable;
